
















import { createComponent, watch, onUnmounted } from "@vue/composition-api";
import useScreenWidth from "@/shared/useScreenWidth";

interface Props {
  visible: boolean;
  width: string;
  title: string;
  fullscreen: boolean;
  closeOnNavigation: boolean;
}

export default createComponent<Props>({
  components: {},
  props: {
    visible: { type: Boolean, required: true },
    width: { default: "600px" },
    title: { type: String, default: "" },
    fullscreen: { type: Boolean, default: false },
    closeOnNavigation: { type: Boolean, default: false },
  },
  setup(props, ctx) {
    let unregisterRouterGuard: any = null;

    function onModalOpen() {
      unregisterRouterGuard = ctx.root.$router.beforeEach((to, from, next) => {
        ctx.emit("update:visible", false);
        next(false);
      });
    }

    function onModalClose() {
      if (unregisterRouterGuard) unregisterRouterGuard();
    }

    onUnmounted(() => {
      if (unregisterRouterGuard) unregisterRouterGuard();
    });

    watch(
      () => props.visible,
      (visible) => {
        if (!props.closeOnNavigation) return;
        if (visible) onModalOpen();
        else onModalClose();
      },
    );

    return { screenWidthPx: useScreenWidth().width };
  },
});
